const CART_UPDATE_EVENT = 'cart:update';
const CART_ERROR_EVENT = 'cart:error';

if (!window.__gvsCartCommerceInitialised) {
  window.__gvsCartCommerceInitialised = true;

  let pendingPageFocus = null;
  let suggestionRefreshTimer = 0;
  let suggestionRefreshController = null;

  const updateLiveRegions = (message) => {
    document.querySelectorAll('[data-gvs-cart-status]').forEach((region) => {
      if (!(region instanceof HTMLElement)) return;

      region.textContent = '';
      window.requestAnimationFrame(() => {
        region.textContent = message;
      });
    });
  };

  const refreshCartSuggestions = () => {
    window.clearTimeout(suggestionRefreshTimer);

    suggestionRefreshTimer = window.setTimeout(async () => {
      const currentSection = document.querySelector('[data-gvs-cart-suggestions][data-section-id]');
      if (!(currentSection instanceof HTMLElement)) return;

      const sectionId = currentSection.dataset.sectionId;
      if (!sectionId) return;

      suggestionRefreshController?.abort();
      suggestionRefreshController = new AbortController();

      try {
        const url = new URL(window.location.href);
        url.search = '';
        url.searchParams.set('section_id', sectionId);

        const response = await fetch(url.toString(), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          cache: 'no-store',
          signal: suggestionRefreshController.signal,
        });

        if (!response.ok) return;

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const nextSection = documentFragment.querySelector('[data-gvs-cart-suggestions]');

        if (nextSection instanceof HTMLElement) {
          currentSection.replaceWith(nextSection);
        }
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return;
        return;
      }
    }, 120);
  };

  const rememberPageFocus = (action) => {
    const page = action.closest('.gvs-cart-page');
    const row = action.closest('[data-cart-item-key]');

    if (!(page instanceof HTMLElement) || !(row instanceof HTMLElement)) return;

    const rows = Array.from(page.querySelectorAll('[data-cart-item-key]'));
    const rowIndex = rows.indexOf(row);
    const actionType = action.classList.contains('quantity-plus')
      ? 'quantity-plus'
      : action.classList.contains('quantity-minus')
        ? 'quantity-minus'
        : 'remove';

    pendingPageFocus = {
      key: row.dataset.cartItemKey || '',
      rowIndex: Math.max(0, rowIndex),
      actionType,
    };
  };

  const restorePageFocus = (attempt = 0) => {
    if (!pendingPageFocus) return;

    const component = document.querySelector('.gvs-cart-page-component');
    if (!(component instanceof HTMLElement)) {
      pendingPageFocus = null;
      return;
    }

    if (component.getAttribute('aria-busy') === 'true' && attempt < 12) {
      window.setTimeout(() => restorePageFocus(attempt + 1), 45);
      return;
    }

    const page = component.querySelector('.gvs-cart-page');
    if (!(page instanceof HTMLElement)) {
      pendingPageFocus = null;
      return;
    }

    if (page.classList.contains('cart-page--empty')) {
      const emptyAction = page.querySelector('.gvs-cart-empty-actions__primary');
      if (emptyAction instanceof HTMLElement) emptyAction.focus({ preventScroll: true });
      pendingPageFocus = null;
      return;
    }

    if (pendingPageFocus.actionType !== 'remove' && pendingPageFocus.key) {
      const rows = Array.from(page.querySelectorAll('[data-cart-item-key]'));
      const matchingRow = rows.find((row) => row instanceof HTMLElement && row.dataset.cartItemKey === pendingPageFocus.key);
      const matchingAction = matchingRow?.querySelector(`.${pendingPageFocus.actionType}`);

      if (matchingAction instanceof HTMLElement) {
        matchingAction.focus({ preventScroll: true });
        pendingPageFocus = null;
        return;
      }
    }

    const remainingRows = Array.from(page.querySelectorAll('[data-cart-item-key]'));
    const fallbackRow = remainingRows[Math.min(pendingPageFocus.rowIndex, remainingRows.length - 1)]
      || remainingRows[remainingRows.length - 1];
    const fallbackLink = fallbackRow?.querySelector('.cart-items__title');
    const checkoutButton = page.querySelector('.cart__checkout-button');

    if (fallbackLink instanceof HTMLElement) {
      fallbackLink.focus({ preventScroll: true });
    } else if (checkoutButton instanceof HTMLElement) {
      checkoutButton.focus({ preventScroll: true });
    }

    pendingPageFocus = null;
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const action = event.target.closest(
      'cart-items-component .quantity-minus, cart-items-component .quantity-plus, cart-items-component .cart-items__remove'
    );

    if (!action) return;

    if (action.closest('.gvs-cart-page')) {
      rememberPageFocus(action);
    }

    updateLiveRegions(
      action.classList.contains('cart-items__remove')
        ? 'Removing item from basket…'
        : 'Updating basket…'
    );
  });

  document.addEventListener(CART_UPDATE_EVENT, (event) => {
    const itemCount = Number(event.detail?.data?.itemCount);
    const message = Number.isFinite(itemCount)
      ? `${itemCount} ${itemCount === 1 ? 'item' : 'items'} in your basket.`
      : 'Your basket has been updated.';

    window.setTimeout(() => updateLiveRegions(message), 80);
    refreshCartSuggestions();

    if (pendingPageFocus) {
      window.setTimeout(() => restorePageFocus(), 70);
    }
  });

  document.addEventListener(CART_ERROR_EVENT, (event) => {
    pendingPageFocus = null;
    updateLiveRegions(
      event.detail?.data?.message || 'The basket could not be updated. Please try again.'
    );
  });

  document.addEventListener('submit', (event) => {
    if (
      !(event.target instanceof HTMLFormElement) ||
      !['cart-form', 'cart-drawer-form'].includes(event.target.id)
    ) {
      return;
    }

    const submitter = event.submitter;
    if (!(submitter instanceof HTMLElement) || submitter.getAttribute('name') !== 'checkout') return;

    submitter.setAttribute('aria-busy', 'true');
    submitter.classList.add('is-loading');
    updateLiveRegions('Opening secure checkout…');
  });
}
